var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.243,
    height: 44.873,
    viewBox: "0 0 36.243 44.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ae236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8acd2e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "signup",
    d: "M3476.823,10216.131v-44.873h28.29l7.953,8.448v36.425Zm2.877-2.876h30.49v-30.493h-8.053v-8.63H3479.7Zm25.313-33.367h4.3l-4.3-4.42Zm-8.984,30.705c-1.062-.607-.8-.448-.8-11.878a5.346,5.346,0,0,1,5.351-5.276,5.275,5.275,0,0,1,0,10.55,7.294,7.294,0,0,1-2.474-.582v3.423l1.741-.981a1.524,1.524,0,0,1,2.041.513,1.44,1.44,0,0,1-.515,1.969l-3.846,2.257a1.5,1.5,0,0,1-.753.2A1.524,1.524,0,0,1,3496.029,10210.593Zm2.228-11.878a2.4,2.4,0,1,0,2.4-2.4A2.4,2.4,0,0,0,3498.257,10198.715Zm5.031,10.63v-4.115a1.437,1.437,0,0,1,2.874,0v4.115a1.437,1.437,0,0,1-2.874,0Zm-18.412-5.3v-2.877h7.479v2.877Zm0-6.9v-2.877h7.479v2.877Zm0-6.33v-2.877h19.56v2.877Zm0-6.9v-2.877h13.807v2.877Z",
    transform: "translate(-3476.823 -10171.258)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.982c554e.svg";
export { ForwardRef as ReactComponent };